var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgIoIcon = function SvgIoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.065 5.7.857 14.058l9.208-8.356zm.103.109a3.087 3.087 0 0 1 4.363-4.364 3.087 3.087 0 0 1-4.363 4.364zm4.11 12.491 9.208-8.357-9.208 8.356z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.175 18.191a3.087 3.087 0 0 1-4.364 4.364 3.087 3.087 0 0 1 4.364-4.364z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIoIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;